import React from "react";
import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import PortfolioSummaryTable from "./PortfolioSummaryTable";
import PortfolioTabs from "./PortfolioTabs";
import BenchMarkTable from "../PerformanceDashboard/BenchMarkTable";
import {
  extraPortfolioBenchmarksFor,
} from "../../utils/portfolioBenchmarks";

const PortfolioMainContent = ({
  titleText,
  longShortLabels,
  totals,
  onToggleGridViewSummary,
  value,
  onChange,
  onPositionPerformanceClick,
  livePrices,
}) => {
  const { user, userInfo } = useSelector((state) => state?.users);
  const extraBenchmarks = extraPortfolioBenchmarksFor(user, userInfo);

  return (
    <Box sx={{ mb: 3 }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 3,
          alignItems: "stretch",
        }}
      >
        <Box sx={{ width: "50%", display: "flex" }}>
          <PortfolioSummaryTable
            titleText={titleText}
            longShortLabels={longShortLabels}
            totals={totals}
            onToggleGridViewSummary={onToggleGridViewSummary}
          />
        </Box>
        <Box sx={{ width: "50%", display: "flex" }}>
          <BenchMarkTable
            marketData={livePrices}
            extraBenchmarks={extraBenchmarks}
          />
        </Box>
      </Box>

      <Box sx={{ width: "50%", mt: 2 }}>
        <PortfolioTabs
          value={value}
          onChange={onChange}
          onPositionPerformanceClick={onPositionPerformanceClick}
        />
      </Box>
    </Box>
  );
};

export default PortfolioMainContent;
